// extracted by mini-css-extract-plugin
export default {"empty":"CodigoPromocionalSelector_empty__TtB48"};